var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticStyle: { top: "20px", height: "95%" },
      attrs: {
        width: _vm.modalWidth,
        visible: _vm.visible,
        title: _vm.title,
        wrapClassName: _vm.wrapClassNameInfo(),
        cancelText: "关闭(ESC)",
      },
      on: { ok: _vm.handleSubmit, cancel: _vm.close },
    },
    [
      _c(
        "a-row",
        {
          staticStyle: { padding: "10px", margin: "-10px" },
          attrs: { gutter: 10 },
        },
        [
          _c("a-col", { attrs: { md: 24, sm: 24 } }, [
            _c(
              "div",
              { staticClass: "table-page-search-wrapper" },
              [
                _c(
                  "a-form",
                  {
                    attrs: { layout: "inline" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.onSearch.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "a-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { md: 6, sm: 8 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  label: "关键词",
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                },
                              },
                              [
                                _c("a-input", {
                                  ref: "material",
                                  attrs: {
                                    placeholder:
                                      "请输入条码、名称、助记码等查询",
                                  },
                                  model: {
                                    value: _vm.queryParam.q,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryParam, "q", $$v)
                                    },
                                    expression: "queryParam.q",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { md: 6, sm: 8 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  label: "规格型号",
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                },
                              },
                              [
                                _c("a-input", {
                                  attrs: { placeholder: "请输入规格、型号" },
                                  model: {
                                    value: _vm.queryParam.standardOrModel,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParam,
                                        "standardOrModel",
                                        $$v
                                      )
                                    },
                                    expression: "queryParam.standardOrModel",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { md: 6, sm: 8 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "仓库",
                                },
                              },
                              [
                                _c(
                                  "a-select",
                                  {
                                    attrs: {
                                      placeholder: "选择仓库",
                                      dropdownMatchSelectWidth: false,
                                      showSearch: "",
                                      optionFilterProp: "children",
                                      "allow-clear": "",
                                    },
                                    on: { change: _vm.onDepotChange },
                                    model: {
                                      value: _vm.queryParam.depotId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "depotId", $$v)
                                      },
                                      expression: "queryParam.depotId",
                                    },
                                  },
                                  _vm._l(_vm.depotList, function (item, index) {
                                    return _c(
                                      "a-select-option",
                                      { key: index, attrs: { value: item.id } },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(item.depotName) +
                                            "\n                  "
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "table-page-search-submitButtons",
                            staticStyle: { float: "left", overflow: "hidden" },
                          },
                          [
                            _c(
                              "a-col",
                              { attrs: { md: 6, sm: 8 } },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.loadMaterialData(1)
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.searchReset(1)
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                                _c(
                                  "a-tooltip",
                                  {
                                    attrs: {
                                      title: "没查询到，决定新增商品！",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        staticStyle: { "margin-left": "8px" },
                                        on: { click: _vm.addMaterial },
                                      },
                                      [_vm._v("新增")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    on: { click: _vm.handleToggleSearch },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.toggleSearchStatus
                                            ? "收起"
                                            : "展开"
                                        ) +
                                        "\n                  "
                                    ),
                                    _c("a-icon", {
                                      attrs: {
                                        type: _vm.toggleSearchStatus
                                          ? "up"
                                          : "down",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.toggleSearchStatus
                      ? [
                          _c(
                            "a-row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 8 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: "颜色",
                                        labelCol: { span: 5 },
                                        wrapperCol: { span: 18, offset: 1 },
                                      },
                                    },
                                    [
                                      _c("a-input", {
                                        attrs: { placeholder: "请输入颜色" },
                                        model: {
                                          value: _vm.queryParam.color,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryParam,
                                              "color",
                                              $$v
                                            )
                                          },
                                          expression: "queryParam.color",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 8 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: "品牌",
                                        labelCol: { span: 5 },
                                        wrapperCol: { span: 18, offset: 1 },
                                      },
                                    },
                                    [
                                      _c("a-input", {
                                        attrs: { placeholder: "请输入品牌" },
                                        model: {
                                          value: _vm.queryParam.brand,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryParam,
                                              "brand",
                                              $$v
                                            )
                                          },
                                          expression: "queryParam.brand",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 8 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol,
                                        label: "类别",
                                      },
                                    },
                                    [
                                      _c("a-tree-select", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          dropdownStyle: {
                                            maxHeight: "200px",
                                            overflow: "auto",
                                          },
                                          "allow-clear": "",
                                          treeData: _vm.categoryTree,
                                          placeholder: "请选择类别",
                                        },
                                        model: {
                                          value: _vm.queryParam.categoryId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryParam,
                                              "categoryId",
                                              $$v
                                            )
                                          },
                                          expression: "queryParam.categoryId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 8 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: "制造商",
                                        labelCol: { span: 5 },
                                        wrapperCol: { span: 18, offset: 1 },
                                      },
                                    },
                                    [
                                      _c("a-input", {
                                        attrs: { placeholder: "请输入制造商" },
                                        model: {
                                          value: _vm.queryParam.mfrs,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryParam,
                                              "mfrs",
                                              $$v
                                            )
                                          },
                                          expression: "queryParam.mfrs",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 8 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: _vm.queryTitle.mp1,
                                        labelCol: { span: 5 },
                                        wrapperCol: { span: 18, offset: 1 },
                                      },
                                    },
                                    [
                                      _c("a-input", {
                                        attrs: {
                                          placeholder:
                                            "请输入" + _vm.queryTitle.mp1,
                                        },
                                        model: {
                                          value: _vm.queryParam.otherField1,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryParam,
                                              "otherField1",
                                              $$v
                                            )
                                          },
                                          expression: "queryParam.otherField1",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 8 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: _vm.queryTitle.mp2,
                                        labelCol: { span: 5 },
                                        wrapperCol: { span: 18, offset: 1 },
                                      },
                                    },
                                    [
                                      _c("a-input", {
                                        attrs: {
                                          placeholder:
                                            "请输入" + _vm.queryTitle.mp2,
                                        },
                                        model: {
                                          value: _vm.queryParam.otherField2,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryParam,
                                              "otherField2",
                                              $$v
                                            )
                                          },
                                          expression: "queryParam.otherField2",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 8 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: _vm.queryTitle.mp3,
                                        labelCol: { span: 5 },
                                        wrapperCol: { span: 18, offset: 1 },
                                      },
                                    },
                                    [
                                      _c("a-input", {
                                        attrs: {
                                          placeholder:
                                            "请输入" + _vm.queryTitle.mp3,
                                        },
                                        model: {
                                          value: _vm.queryParam.otherField3,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryParam,
                                              "otherField3",
                                              $$v
                                            )
                                          },
                                          expression: "queryParam.otherField3",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 24 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: "序列号",
                                        labelCol: _vm.labelCol,
                                        wrapperCol: _vm.wrapperCol,
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          attrs: { placeholder: "有无序列号" },
                                          model: {
                                            value:
                                              _vm.queryParam.enableSerialNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "enableSerialNumber",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryParam.enableSerialNumber",
                                          },
                                        },
                                        [
                                          _c(
                                            "a-select-option",
                                            { attrs: { value: "1" } },
                                            [_vm._v("有")]
                                          ),
                                          _c(
                                            "a-select-option",
                                            { attrs: { value: "0" } },
                                            [_vm._v("无")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 24 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        label: "批号",
                                        labelCol: { span: 5 },
                                        wrapperCol: { span: 18, offset: 1 },
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          attrs: { placeholder: "有无批号" },
                                          model: {
                                            value:
                                              _vm.queryParam.enableBatchNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "enableBatchNumber",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryParam.enableBatchNumber",
                                          },
                                        },
                                        [
                                          _c(
                                            "a-select-option",
                                            { attrs: { value: "1" } },
                                            [_vm._v("有")]
                                          ),
                                          _c(
                                            "a-select-option",
                                            { attrs: { value: "0" } },
                                            [_vm._v("无")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c("a-table", {
                  ref: "table",
                  attrs: {
                    scroll: _vm.scrollTrigger,
                    size: "middle",
                    rowKey: "id",
                    columns: _vm.columns,
                    dataSource: _vm.dataSource,
                    pagination: _vm.ipagination,
                    rowSelection: {
                      selectedRowKeys: _vm.selectedRowKeys,
                      onChange: _vm.onSelectChange,
                      type: _vm.getType,
                    },
                    loading: _vm.loading,
                    customRow: _vm.rowAction,
                  },
                  on: { change: _vm.handleTableChange },
                  scopedSlots: _vm._u([
                    {
                      key: "customBarCode",
                      fn: function (text, record) {
                        return [
                          _c(
                            "div",
                            {
                              style: record.imgName
                                ? "float:left;line-height:30px"
                                : "float:left;",
                            },
                            [_vm._v(_vm._s(record.mBarCode))]
                          ),
                          _c(
                            "a-popover",
                            { attrs: { placement: "right", trigger: "click" } },
                            [
                              _c("template", { slot: "content" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getImgUrl(
                                      record.imgName,
                                      record.imgLarge
                                    ),
                                    width: "500px",
                                  },
                                }),
                              ]),
                              record.imgName
                                ? _c("div", { staticClass: "item-info" }, [
                                    record.imgName
                                      ? _c("img", {
                                          staticClass: "item-img",
                                          attrs: {
                                            src: _vm.getImgUrl(
                                              record.imgName,
                                              record.imgSmall
                                            ),
                                            title: "查看大图",
                                          },
                                        })
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                    {
                      key: "customName",
                      fn: function (text, record) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(record.name) +
                              "\n            "
                          ),
                          record.enableSerialNumber == 1
                            ? _c("a-tag", { attrs: { color: "orange" } }, [
                                _vm._v("序"),
                              ])
                            : _vm._e(),
                          record.enableBatchNumber == 1
                            ? _c("a-tag", { attrs: { color: "orange" } }, [
                                _vm._v("批"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("material-modal", {
        ref: "materialModalForm",
        on: { ok: _vm.modalFormOk },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }